import React, { useMemo } from 'react';
import { useStateBus } from '~/state/bridge';
import AgentsClient from '~/state/Agents/client';
import { getAgents } from '~/state/Agents/selectors';

import useSlideDown from '~/theseus/hooks/useSlideDown';

const handleChange = (e) => {
  if (e.target.value === '') {
    AgentsClient.agents.setId(null);
  } else {
    AgentsClient.agents.setId(parseInt(e.target.value, 10));
  }
};

const produceAgentOptions = agents => agents.map(agent => (
  <option key={agent.id} value={agent.id}>
    {`${agent.role} - ${agent.name}`}
  </option>
));

const AgentLanding = () => {
  const agents = useStateBus(getAgents);

  const agentOptions = useMemo(() => produceAgentOptions(agents), [agents]);
  useSlideDown('#agent-landing-container', agents.length > 0);

  return (
    <div id="agent-landing-container" className="link__row agent-landing">
      <p className="description">
        Assign leads using your website&apos;s lead assignment settings or to a specific
        agent.
      </p>
      <label htmlFor="agent-select">Lead Assignment</label>
      <select id="agent-select" className="agent-landing__select" onChange={handleChange}>
        <option value="" selected>Default Lead Assignment</option>
        { agentOptions }
      </select>
    </div>
  );
};

export default AgentLanding;
